<template>
  <div id="printer-modal" class="modal fade bottomSheet" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div class="mdl-grid">
            <div
              class="mdl-card mdl-shadow--2dp mdl-cell--4-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
            >
              <div class="mdl-card__title card-image"></div>
              <div class="mdl-card__supporting-text">
                <div class="title">
                  <div class="manufacturer">
                    {{ openedPrinter.parsed.manufacturer }}
                  </div>
                  <div class="model">{{ openedPrinter.parsed.model }}</div>
                </div>
                <div class="serialNumber">
                  {{ t("Serial Number") + ": " + openedPrinter.serialNumber }}
                </div>
                <div class="user">
                  {{
                    `${t("Status")}: ${
                      openedPrinter.status && openedPrinter.status.code
                        ? `${openedPrinter.status.code} - ${openedPrinter.status.description}`
                        : "ok"
                    }`
                  }}
                </div>
              </div>
            </div>
            <!-- <div class="mdl-card mdl-shadow--2dp mdl-cell--3-col mdl-cell--12-col-tablet mdl-cell--12-col-phone">
                      <div class="mdl-card__supporting-text">
                        <div class="title">Service Calls</div>
                      </div>
                    </div> -->
            <div
              class="mdl-card mdl-shadow--2dp mdl-cell--4-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
            >
              <div
                class="chart-container"
                style="position: relative; height:100%;"
              >
                <canvas></canvas>
              </div>
            </div>
            <div
              class="mdl-card list mdl-shadow--2dp mdl-cell--4-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
            >
              <div class="dd"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="service-call-modal" class="modal fade bottomSheet" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div
            class="text-center"
            style="margin-bottom: 20px;margin-top: 70px;"
          >
            <h4 class="mb-4" style="margin: 0 !important;">Service Call</h4>
            <div class="title">
              {{ openedPrinter.parsed.manufacturer }}
              {{ openedPrinter.parsed.model }}
            </div>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <div style="margin-top: 10px;">
                <textarea placeholder="Write something..."></textarea>
              </div>
              <div class="order-supplies">
                <li
                  v-for="supply in openedPrinter.parsed.markerSupplies"
                  :key="supply.name"
                  :class="['row', supply.color]"
                >
                  <div class="left">
                    {{
                      getComputed("columnsConnected")[supply.name.toLowerCase()]
                        ? t(getComputed("columnsConnected")[supply.name.toLowerCase()])
                        : t(supply.name)
                    }}
                  </div>
                  <div class="separator"></div>
                  <NumberInputSpinner
                    class="right"
                    :min="0"
                    :max="99"
                    :integerOnly="true"
                  />
                </li>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-link btn-link-secondary"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="btn btn-link btn-link-info"
              type="button"
              data-dismiss="modal"
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "nestable2/jquery.nestable.css";
import NumberInputSpinner from "vue-number-input-spinner";
import notFound from "../assets/img/image-not-found.jpg";
require("nestable2");

import { mapState } from "vuex";
export default {
  props: ["openedPrinter"],
  data() {
    return {
      chart: undefined,
      counters: undefined
    };
  },
  methods: {
    getComputed(property) {
      return this[property];
    },
    changeImg: function(url) {
      const imgUrl = url ? url : url === null ? notFound : "";
      const _this = this;
      const imgCard = $(_this.$el).find(".mdl-card .card-image");
      imgCard
        .css("background-image", "url('" + imgUrl + "')")
        .css("background-color", url === null ? "#e7e7e7" : "#ffffff");
    },
    processObj: function({ value, ...rest }, r = []) {
      var _this = this;
      Object.entries(rest).forEach(([k, v], i) => {
        var value = v.value;
        if (value != null) {
          value = v.value.toLocaleString("en");
        } else {
          if (value !== 0) {
            value = "";
          }
        }
        if (Array.isArray(r)) {
          r[i] = { id: `${_this.t(k)}: ${value}` };
          _this.processObj(v, r[i]);
        } else {
          r.children = r.children || [];
          r.children[i] = { id: `${_this.t(k)}: ${value}` };
          _this.processObj(v, r.children[i]);
        }
      });
      return r;
    }
    // openQrCode: function() {
    //   $("#qrcode-servicecall-modal").modal("show");
    //   const link = `https://dashboard.maprinter.com/${this.openedPrinter.snapshot.ref.path
    //     .replace("computers/", "?computer=")
    //     .replace("/printers/", "&printer=")}`;
    //   this.$root.$children[0].$refs.qrcodeServiceCall.open(link);
    // }
    // openService: () => {
    //   $("#service-call-modal").modal("show");
    // }
  },
  computed: {
    ...mapState({
      storage: state => state.storage,
      columnsConnected: state => state.columnsConnected
    })
  },
  mounted() {
    var _this = this;
    var $dd = $(_this.$el).find(".dd");
    $dd.nestable();
  },
  components: {
    NumberInputSpinner
  },
  watch: {
    openedPrinter: function(openedPrinter) {
      var _this = this;

      if (_this.chart) {
        _this.chart.destroy();
      }

      _this.chart = undefined;
      _this.counters = undefined;
      _this.changeImg("");
      var printer = openedPrinter.parsed;

      _this.counters = printer.counters.tree;
      var $dd = $(_this.$el).find(".dd");
      $dd.nestable("removeAll", function() {
        $dd.nestable("destroy");
        if (!_this.counters.total.color && _this.openedPrinter.color) {
          _this.counters.total.color = { value: _this.openedPrinter.color };
          var black =
            Number(_this.openedPrinter.total.replace(/,/g, "")) -
            Number(_this.openedPrinter.color.replace(/,/g, ""));
          _this.counters.total.black = { value: black.toLocaleString() };
        }
        $dd.nestable({
          json: _this.processObj(_this.counters),
          onDragStart: function(l, e) {
            return false;
          }
        });
      });

      if (printer.manufacturer && printer.model) {
        var manufacturer = printer.manufacturer;
        var model = printer.model;

        if (
          model.substring(0, model.split(" ")[0].length).toLowerCase() ==
          manufacturer.toLowerCase()
        )
          model = model.substring(model.split(" ")[0].length + 1);

        var modelQuery =
          manufacturer.toString().trim() + " " + model.toString().trim();
        modelQuery = modelQuery
          .toString()
          .replace(/(\;.+|\sv.+|\s[a-zA-Z0-9]+\..+)/g, "")
          .trim();
        var modelPic = _this.storage
          .ref()
          .child(`images/mfp/${modelQuery.replace(/\//g, "|")}.png`);

        modelPic
          .getDownloadURL()
          .then(function(url) {
            _this.changeImg(url);
          })
          .catch(function(error) {
            console.log(modelQuery + " image not found.");
            _this.changeImg(null);
          });
      }

      const $el = $(_this.$el);
      const ctx = $el.find("canvas");
      const supplies = printer.markerSupplies;
      if (supplies) {
        const labels = [];
        const data = [];
        const backgroundColor = [];
        const borderColor = [];
        $.each(supplies, function(index, supply) {
          const column = _this.columnsConnected[supply.name.toLowerCase()]
            ? _this.columnsConnected[supply.name.toLowerCase()]
            : supply.name;
          labels.push([
            _this.t(column) /* , ...supply.description.split(";") */
          ]);
          data.push(supply.value);
          const color = supply.color ? supply.color : "grey";
          if (color === "tri-color") {
            const bar_ctx = ctx[0].getContext("2d");
            const background = bar_ctx.createLinearGradient(0, 0, 0, 600);
            background.addColorStop(0, "cyan");
            // background.addColorStop(0.5, "magenta");
            background.addColorStop(1, "yellow");
            backgroundColor.push(background);
            borderColor.push("#000000");
          } else {
            backgroundColor.push(_this.colorToRGBA(color, "0.4"));
            borderColor.push(_this.colorToRGBA(color));
          }
        });

        setTimeout(() => {
          _this.chart = new Chart(ctx, {
            type: "horizontalBar",
            data: {
              labels,
              datasets: [
                {
                  label: this.t("Percentage"),
                  data,
                  backgroundColor,
                  borderColor,
                  borderWidth: 1
                }
              ]
            },
            options: {
              barWidth: 20,
              barHeight: 20,
              scales: {
                xAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      min: 0,
                      max: 100,
                      stepSize: 25,
                      callback: function(value) {
                        return value + "%";
                      }
                    }
                  }
                ],
                yAxes: [
                  {
                    barPercentage: 0.5,
                    maxBarThickness: 50
                  }
                ]
              },
              maintainAspectRatio: false,
              legend: {
                display: false
              }
            }
          });
        }, 500);
      }
    }
  }
};
</script>
<style lang="scss">
$height: 75vh;

#app {
  #service-call-modal {
    .modal-dialog {
      @media (max-width: 767.9px) {
        height: 100vh;
      }
      .modal-content {
        background-color: rgba(255, 255, 255, 0.95);
        .modal-body {
          .order-supplies {
            margin: 20px 0;
            margin-top: -5px;
            .row {
              margin: 0;
              list-style: none;
              background: white;
              border-bottom: 1px solid #e2e2e2;
              height: 35px;
              width: 100%;
              display: flex;
              align-items: flex-end;
              &.cyan {
                .right {
                  .vnis__button {
                    background: rgba(0, 255, 255, 0.4);
                    color: black;
                  }
                }
              }
              &.magenta {
                .right {
                  .vnis__button {
                    background: rgba(255, 0, 255, 0.4);
                    color: black;
                  }
                }
              }
              &.yellow {
                .right {
                  .vnis__button {
                    background: rgba(255, 255, 0, 0.4);
                    color: black;
                  }
                }
              }
              .left {
                line-height: 35px;
                padding-left: 10px;
              }
              .separator {
                flex-grow: 1;
              }
              .right {
                .vnis__button {
                  background: rgba(0, 0, 0, 0.4);
                  color: white;
                  border-bottom: 1px solid #e2e2e2;
                  width: 35px;
                  height: 35px;
                }
                .vnis__input {
                  border: 0;
                  border-bottom: 1px solid #e2e2e2;
                  width: unset;
                  height: 35px;
                }
              }
            }
          }
          textarea {
            &::placeholder {
              color: white;
            }
            width: 100%;
            height: 75px;
            border: 1px solid #2089a6;
            background: rgba(9, 155, 195, 0.6);
            color: white;
            text-align: center;
            outline: none;
            font-size: 14px;
          }
        }
        .modal-footer {
          padding: 10px;
          .btn-link-info {
            color: #000000;
            background: #dff8ff;
            border: 1px solid #52b9d5;
          }
        }
      }
    }
  }
  .modal {
    &.bottomSheet {
      &.show {
        .modal-dialog {
          bottom: 0vh;
          opacity: 1;
        }
      }
      .modal-dialog {
        position: absolute;
        margin: 0;
        width: 100%;
        max-width: 100%;
        height: $height;
        bottom: -$height;
        opacity: 0;
        transition: opacity 0.1s ease-out, bottom 0.1s ease-out;
        .modal-content {
          height: 100%;
          max-width: 100%;
          margin: 0;
          background-color: rgba(255, 255, 255, 0.8);
          border-radius: 0;
          .modal-body {
            padding: 0;
            @media (max-width: 767.9px) {
              margin-bottom: 16px;
            }
            .mdl-grid {
              height: $height - 0.5vh;
              .mdl-card {
                margin: 8px;
                max-height: calc(100% - 16px);
                &.list {
                  overflow: auto;
                }
                .card-image {
                  background-size: contain;
                  background-position: center;
                  background-repeat: no-repeat;
                  min-height: calc($height / 2);
                  margin: 10px;
                  padding: 0;
                }
                @media (max-width: 767.9px) {
                  .card-image {
                    min-height: 30vh;
                  }
                }
                .mdl-card__supporting-text {
                  padding: 10px;
                  width: 100%;
                  text-align: center;
                  padding-bottom: 50px;
                  .title {
                    line-height: 30px;
                    .manufacturer {
                      line-height: 20px;
                      font-size: 21px;
                    }
                    .model {
                      font-size: 16px;
                    }
                  }
                  .button {
                    background: #099bc3;
                    color: white;
                    box-shadow: 0px 1px 0px #00576f;
                    font-size: 16px;
                    padding: 10px;
                    position: absolute;
                    bottom: 1px;
                    left: 0px;
                    width: 100%;
                    cursor: pointer;
                    text-transform: capitalize;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BottomModal.vue